export const archivoRobotoFontFamily = 'Archivo,Roboto,sans-serif';
export const interRobotoFontFamily = 'Inter,Roboto,sans-serif';
